"use strict";
/**
 * 行情延迟提示框
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsonp_1 = __importDefault(require("./modules/jsonp"));
var cookie_1 = __importDefault(require("./modules/cookie"));
var modal_1 = require("./modules/modal");
var qiquan_1 = require("./modules/modal/qiquan");
require("./index.css");
var wenjuan_1 = require("./modules/modal/wenjuan");
//判断手机号不是国内
//判断是海外
//展示提示窗
//如果是海外手机，不管在哪里，都弹 ；如果是国内手机，不管在哪里，都不弹；如果不知道手机在哪里，就按在哪里，如果在国内，不弹，如果在海外，弹
var cookie_mtp = cookie_1["default"].get('mtp'); // “0”： 无手机  “1”： 有手机，中国大陆 “2” ：有手机，非大陆（海外港澳台）
var cookie_ut = cookie_1["default"].get('ut');
var cookie_wbp2uorgt = cookie_1["default"].get('wbp2uorgt'); //0表示未知（默认），1表示个人用户，2表示机构用户
function open() {
    //验证页面是否符合条件
    if (!isSZPage() && !isQiquanPage()) {
        return false;
    }
    if (cookie_ut && cookie_mtp == '1') { //国内手机号 不弹
        return false;
    }
    else if (cookie_ut && cookie_mtp == '2') { //国外手机号 弹
        openSZOption();
        return false;
    }
    else {
        //未知手机号归属 通过ip判断
        (0, jsonp_1["default"])('https://push2.eastmoney.com/api/qt/stock/get', {
            param: 'cb',
            prefix: 'quotedelaytip'
        }, function (err, data) {
            if (data && data.lt && data.lt == 2) { //海外
                if (cookie_ut) { //海外登录
                    openSZOption();
                }
                else { //海外未登录 只弹期权
                    if (isQiquanPage()) {
                        (0, qiquan_1.modal)();
                        bindListenHash();
                    }
                }
            }
        });
    }
}
/** 弹出上证或者期权 */
function openSZOption() {
    if (isQiquanPage()) {
        (0, qiquan_1.modal)();
        bindListenHash();
    }
    else {
        //获取用户身份
        (0, jsonp_1["default"])('//tzzpg.eastmoney.com/questionnaireapi/questionnaire/getQuestionnaireResultJsonp?source=SZ', {
            param: 'callback',
            prefix: 'quotedelaytipsf'
        }, function (err, data) {
            if (data && data.success && data.data != undefined) { //data直接返回结果 0：未答卷；1：机构用户, 2：个人用户
                if (data.data == '0') {
                    cookie_1["default"].set('wbp2uorgt', '0', 7, '.eastmoney.com');
                    (0, wenjuan_1.openWenJuan)();
                }
                else if (data.data == '1') {
                    cookie_1["default"].set('wbp2uorgt', '2', 365, '.eastmoney.com');
                    (0, modal_1.modal)(true);
                }
                else if (data.data == '2') {
                    cookie_1["default"].set('wbp2uorgt', '1', 365, '.eastmoney.com');
                }
            }
        });
    }
}
/** 是否是上证延迟提示页面 */
function isSZPage() {
    var thishref = self.location.href.toLowerCase();
    var domainlist = [
        'www.eastmoney.com',
        'quote.eastmoney.com',
        'data.eastmoney.com',
        'finance.eastmoney.com',
        'stock.eastmoney.com',
        'wap.eastmoney.com',
        'emwap.eastmoney.com',
        'hf-wap.eastmoney.com',
        'guba.eastmoney.com',
        'mguba.eastmoney.com',
        'gubatopic.eastmoney.com'
    ];
    var domainblack = [
        'wap.eastmoney.com/h5/',
        'emwap.eastmoney.com/h5/',
        'hf-wap.eastmoney.com/h5/'
    ];
    var allow = false;
    for (var i = 0; i < domainlist.length; i++) {
        if (thishref.indexOf(domainlist[i]) >= 0 && thishref.indexOf(domainlist[i]) < 10) {
            allow = true;
            break;
        }
    }
    for (var i = 0; i < domainblack.length; i++) {
        if (thishref.indexOf(domainblack[i]) >= 0 && thishref.indexOf(domainblack[i]) < 10) {
            allow = false;
            break;
        }
    }
    return allow;
}
/** 行情中心期权hash */
var qiquan_hashlist = [
    '#options_sh50etf_all',
    '#options_sh50etf_call',
    '#options_sh50etf_put',
    '#options_sz50etf_txbj',
    '#options_sz50etf_all',
    '#options_sz50etf_rengou',
    '#options_sz50etf_rengu',
    '#options_sahs300etf_txbj',
    '#options_sahs300etf_all',
    '#options_sahs300etf_rengou',
    '#options_sahs300etf_rengu',
    '#options_szetf_all',
    '#options_szetf_call',
    '#options_szetf_put',
    '#options_sehs300etf_txbj',
    '#options_sehs300etf_all',
    '#options_sehs300etf_rengou',
    '#options_sehs300etf_rengu',
    '#options_sezz500etf_txbj',
    '#options_sezz500etf_all',
    '#options_sezz500etf_rengou',
    '#options_sezz500etf_rengu',
    '#options_secybetf_txbj',
    '#options_secybetf_all',
    '#options_secybetf_rengou',
    '#options_secybetf_rengu',
];
/** 是否是期权页面 */
function isQiquanPage() {
    var href = location.href.toLowerCase();
    //数据中心期权页面
    // if(href.indexOf('//data.eastmoney.com/other/valueAnal.html') > 0 || href.indexOf('//data.eastmoney.com/other/riskanal.html') > 0 || href.indexOf('//data.eastmoney.com/other/premium.html') > 0){
    //   return true
    // }  
    //web行情单页
    //@ts-ignore
    if (href.indexOf('//quote.eastmoney.com/qiquan/') > 0 && (window.quotedata && window.quotedata.market == 10 || window.quotedata && window.quotedata.market == 12)) {
        return true;
    }
    //wap行情单页
    if (href.indexOf('//wap.eastmoney.com/quote/stock/10.') > 0 || href.indexOf('//emwap.eastmoney.com/quote/stock/10.') > 0 || href.indexOf('//hf-wap.eastmoney.com/quote/stock/10.') > 0 || href.indexOf('//wap.eastmoney.com/quote/stock/12.') > 0 || href.indexOf('//emwap.eastmoney.com/quote/stock/12.') > 0 || href.indexOf('//hf-wap.eastmoney.com/quote/stock/12.') > 0) {
        return true;
    }
    //期权频道
    if (href.indexOf('//option.eastmoney.com/') > 0) {
        return true;
    }
    //wap期权列表
    if (href.indexOf('//wap.eastmoney.com/quote/list.html?mt=qiquan_rengouqiquan') > 0 || href.indexOf('//emwap.eastmoney.com/quote/list.html?mt=qiquan_rengouqiquan') > 0 || href.indexOf('//hf-wap.eastmoney.com/quote/list.html?mt=qiquan_rengouqiquan') > 0 || href.indexOf('//wap.eastmoney.com/quote/list.html?mt=qiquan_renguqiquan') > 0 || href.indexOf('//emwap.eastmoney.com/quote/list.html?mt=qiquan_renguqiquan') > 0 || href.indexOf('//hf-wap.eastmoney.com/quote/list.html?mt=qiquan_renguqiquan') > 0) {
        return true;
    }
    //行情中心 期权
    if (href.indexOf('//quote.eastmoney.com/center/qqsc.html') > 0) {
        return true;
    }
    //行情中心 期权列表
    if (href.indexOf('//quote.eastmoney.com/center/gridlist.html') > 0) {
        var hash_1 = location.hash;
        if (qiquan_hashlist.some(function (v) { return v == hash_1.toLowerCase(); })) {
            return true;
        }
    }
    return false;
}
//监听hash change
function bindListenHash() {
    window.addEventListener('hashchange', function () {
        var hash = location.hash;
        if (qiquan_hashlist.some(function (v) { return v == hash.toLowerCase(); })) {
            (0, qiquan_1.modal)();
        }
    }, false);
}
module.exports = {
    show: open,
    modalShow: modal_1.openModal,
    qiquan_modalShow: qiquan_1.openModal,
    openWenJuan: wenjuan_1.openWenJuan,
    gesf: function () {
        //获取用户身份
        (0, jsonp_1["default"])('//premiumapitest2.eastmoney.com/questionnaireapi/questionnaire/getQuestionnaireResultJsonp?source=SZ', {
            param: 'callback',
            prefix: 'quotedelaytipsf'
        }, function (err, data) {
            if (data && data.success && data.data != undefined) { //data直接返回结果 0：未答卷；1：机构用户, 2：个人用户
                console.info(data);
            }
        });
    },
    openjg: function () {
        (0, modal_1.modal)(true);
    }
};
